import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentView } from '../uicomponentview';
import { CheckboxWithTextCSSStyle } from './checkboxwithtextcss';
import { CheckboxWithTextView } from './checkboxwithtextview';
import { UIComponentCSSStyle } from '../uicomponentcss';


export interface CheckboxWithTextProps extends UIComponentProps
{
    isChecked: boolean; 
    title: string;
    style: CheckboxWithTextCSSStyle;
    onChange(isChecked:boolean, title: string):void;
}
export interface CheckboxWithTextState extends UIComponentState
{
    isChecked: boolean; 
}

export interface CheckboxWithTextHandler extends UIComponentHandler
{  
    onClick():void; 
}

export class CheckboxWithTextComponent extends UIComponentImpl<CheckboxWithTextProps, CheckboxWithTextState, UIDataModel> implements CheckboxWithTextHandler
{
    onChange:Function = ()=>{};

    constructor(props:CheckboxWithTextProps){
        super(props);

        this.state = {isChecked: this.props.isChecked};

        if(this.props.onChange !== undefined){
            this.onChange = this.props.onChange;
        }
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new CheckboxWithTextView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return this.props.style;
    }

    UNSAFE_componentWillReceiveProps(newProps:CheckboxWithTextProps){
        this.setState({isChecked: newProps.isChecked});

        if(newProps.onChange !== undefined){
            this.onChange = newProps.onChange;
        }
    }

    onClick(){
        this.setState((state:any)=>{
            this.onChange(!state.isChecked, this.props.title);
            return {isChecked: !state.isChecked};
        });
    }

    isChecked():boolean{
        return this.state.isChecked;
    }

    validate(): boolean{
        return true;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/checkboxwithtext/checkboxwithtextcomponent.tsx